import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-ps-management-reports',
    template: '<app-reports-view category="PsManagement"></app-reports-view>',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PsManagementReportsComponent {

    constructor() { }

}
